<template>
	<div>
		<div class="condition editFroms" v-loading="loading">
			<div class="contentBigBox">
				<el-form label-width='100px' class="qcFrom scrollbar" ref="newtaskPageFrom" :rules="rules" v-model="distributionFrom">
					<common-title :name="'抽样任务分配'" :icon="'iconfont iconicon-condition'" :line-type="'1'"></common-title>
					<div class="BasicCondition">
						<el-row>
							<el-col :span="12">
								<el-row>
									<el-form-item label="任务名称" prop="Name">
										{{distributionFrom.Name}}
									</el-form-item>
								</el-row>
								<el-row>
									<el-form-item label="可分配数量" prop="Total">
										{{distributionFrom.Total}}份
									</el-form-item>
								</el-row>
							</el-col>
							<el-col :span="12">
								<el-row>
									<el-form-item label="设备类型" prop="Name">
										<span v-if="distributionFrom.ModalityTypes == null||distributionFrom.ModalityTypes == ''">不限</span> 
										<span v-else>{{distributionFrom.ModalityTypes}}</span>
									</el-form-item>
								</el-row>
								<el-row>
									<el-form-item label="抽样部位" prop="BodyParts">
										<span v-if="distributionFrom.BodyParts == null||distributionFrom.BodyParts == ''">不限</span> 
										<span v-else>{{distributionFrom.BodyParts}}</span>
									</el-form-item>
								</el-row>
							</el-col>
						</el-row>
						<el-row>
							<el-form-item label="分配方法" prop="DistributionMethod">
								<el-radio v-model="DistributionMethod" :label="1">平均分配</el-radio>
								<el-radio v-model="DistributionMethod" :label="2">非平均不限医院</el-radio>
								<el-radio v-model="DistributionMethod" :label="3" v-if="distributionFrom.Hospitals&&distributionFrom.Hospitals.length>1">非平均按医院</el-radio>
							</el-form-item>
						</el-row>
						<el-row v-if="DistributionMethod!=1">
							<el-form-item label="分配类型" prop="DistributionType">
								<el-radio v-model="DistributionType" :label="2">按份数</el-radio>
								<el-radio v-model="DistributionType" :label="1">按比例</el-radio>
							</el-form-item>
						</el-row>
					</div>
				</el-form>
				<div class="el-row">
					<div class="el-form-item">
						<label for="ExpertGroupIDList" class="el-form-item__label" style="width: 100px;">专家</label>
						<div class="el-form-item__content marl100">
							<button type="button" @click="expertPopUp" class="el-button expertGroupbtn el-button--default el-button--primary">
								<span>选择专家</span>
							</button>
							<span class="marl20 toopExpert">请至少选择{{distributionFrom.QCTimes}}位专家
								<el-tooltip class="item" effect="dark" placement="bottom">
									<i class="marl5 el-icon-info"></i>
									<div slot="content" class="tableTooltip">
										<div>
											<div>抽样报告共{{distributionFrom.Total/distributionFrom.QCTimes}}份,每份由{{distributionFrom.QCTimes}}位专家进行质控,因此至少需选择{{distributionFrom.QCTimes}}位专家。</div>
										</div>
									</div>
								</el-tooltip>
							</span>
				
						</div>
					</div>
				</div>
				<div v-loading='numLoading'>
					<el-table class="qcTable scrollbar distributionTable" :row-class-name="DistributionMethod==3?tableRowClassName:''"
					 v-if="newWorkTeamFrom.Experts.length>0" :data="newWorkTeamFrom.Experts" :key="Surplusval">
						<el-table-column key="3" prop="Name" label="专家" min-width="170">
							<template slot-scope="scope">
								<div v-if="scope.row.nameType">
									<span>{{scope.row.Name}}</span>
									<span v-if="DistributionMethod!=1">
										(<span v-if="scope.row.MaxQCCount>0">上限{{scope.row.MaxQCCount}}例</span><span v-else>无上限</span>)
									</span>
								</div>
							</template>
						</el-table-column>
			<!-- 			<el-table-column key="99" v-if="DistributionMethod==3" prop="Hospitalslist" label="分配抽样医院" min-width="200">
							<template slot-scope="scope">
								{{scope.row.Hospitalslist}}
								<el-select @change="handleEvents(scope.$index,scope.row,scope.row.Hospitalslist)" size="mini" v-model="scope.row.Hospitalslist"
								 placeholder="请选择医院">
									<el-option v-for="item in distributionFrom.Hospitals" :key="item.uuid" :label="item.HospitalName" :value="item.HospitalGuid">{{item.HospitalName}}
									</el-option>
								</el-select>
							</template>
						</el-table-column> -->
						<el-table-column key="1" v-if="DistributionMethod==3" prop="HospitalName" label="分配抽样医院" min-width="100">
						</el-table-column>
						<el-table-column key="4" v-if="DistributionMethod!=1" prop="DistributionRate" :label="DistributionType==1?'比例设置%':'份数设置'"
						 min-width="100">
							<template slot-scope="scope">
								<input type="number" v-model="scope.row.DistributionRate" class="el-input__inner" size="mini" @focus="handlefocus(scope.$index,scope.row)" @blur="handleChange(scope.$index,scope.row)" />
							</template>
						</el-table-column>
						<el-table-column key="5" prop="Assigned" label="已分配"></el-table-column>
						<el-table-column key="6" prop="Surplus" label="剩余" v-if="DistributionMethod!=1"></el-table-column>
						<el-table-column key="2" v-if="DistributionMethod==3" prop="Count" label="医院抽样数量"></el-table-column>
						<el-table-column prop="" label="操作" width="180">
							<template slot-scope="scope">
								<span class="table-task-btn delete" @click="delterClick(scope.$index,scope.row)">删除</span>
								<el-dropdown trigger="click" size="small" @command="addClick" v-if="DistributionMethod==3&&scope.row.addBtn">
								  <span class="el-dropdown-link table-task-btn detail">
								    添加医院
								  </span>
								  <el-dropdown-menu slot="dropdown">
								    <el-dropdown-item v-for="(item,index) in scope.row.hoslist" :key="index" :command="composeValue(scope.$index,item,index)">{{item.HospitalName}}</el-dropdown-item>
								  </el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
					<div v-if="newWorkTeamFrom.Experts&&newWorkTeamFrom.Experts.length>0" slot="footer" class="dialog-footer footerSetUp">
						<el-button type="primary" class="bigBtn" @click="determine">确定分配</el-button>
						
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="`专家列表 (已选${newWorkTeamFrom.Experts.length}位)`" :visible.sync="dialogVisible" width="80%" :close-on-click-modal='false' class="scrollbar exportFrom dialogFrom">
			<div class="dialogSearch">
				<div class="selectSearch">
					<el-form ref="form" label-width='85px' :model="userParameter" class="selectSearch qcFrom">
						<el-form-item label="关键词" prop="keyword">
							<el-input v-model="userParameter.Keyword" class="name" size="mini" placeholder="姓名/手机号"></el-input>
						</el-form-item>
						<el-form-item label="专家专业" prop="ExpertMajor">
							<el-select size="mini" v-model="userParameter.ExpertMajor" placeholder="请选择专业">
								<el-option v-for="item in detailsRulesParameter.ExpertMajor" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="专家来源" prop="ExpertFromType">
							<el-select size="mini" v-model="userParameter.ExpertFromType" placeholder="请选择来源">
								<el-option v-for="item in detailsRulesParameter.ExpertFromType" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="专家分组" prop="ExpertLevelType">
							<el-select size="mini" v-model="userParameter.ExpertLevelType" placeholder="请选择专家分组">
								<el-option label="无" value="0"></el-option>
								<el-option label="甲" value="甲"></el-option>
								<el-option label="乙" value="乙"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="擅长设备" prop="ModalityTypes">
							<el-select size="mini" v-model="userParameter.ModalityTypes" filterable placeholder="请选择擅长设备">
							    <el-option
							      v-for="item in detailsRulesParameter.ModalityType"
							      :key="item.text" :label="item.text" :value="item.text">
							    </el-option>
							  </el-select>
						</el-form-item>
						<el-form-item label="擅长部位" prop="BodyParts">
							<el-select size="mini" v-model="userParameter.Bodyparts" filterable placeholder="请选择擅长部位">
							    <el-option
							      v-for="item in detailsRulesParameter.BodyPart"
							      :key="item.text" :label="item.text" :value="item.text">
							    </el-option>
							  </el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" class="resetBtn" @click="resetForm('form')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<el-table class="qcTable scrollbar" :data="getUserlist" ref="multipleTable" max-height="350" @row-click="clickRow"
			 @selection-change="handleSelectionChange" @select="selectClick" @select-all="selectAll">
				<el-table-column type="selection" width="80"></el-table-column>
				<el-table-column prop="Name" label="专家姓名" width="100"></el-table-column>
				<el-table-column prop="LoginId" label="手机号">
					<template slot-scope="scope">
						<span v-if="scope.row.LoginId == ' '">—</span>
						<span v-else>{{scope.row.LoginId}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="ExpertFromType" label="专家来源">
					<template slot-scope="scope">
						<span v-show="scope.row.ExpertFromType == 0">未知</span>
						<span v-show="scope.row.ExpertFromType == 1">专委会</span>
						<span v-show="scope.row.ExpertFromType == 2">集团外</span>
						<span v-show="scope.row.ExpertFromType == 3">集团内</span>
					</template>
				</el-table-column>
				<el-table-column prop="ExpertLevelType" label="专家分组">
					<template slot-scope="scope">
						<span v-if="scope.row.ExpertLevelType == 0">—</span>
						<span v-else>{{scope.row.ExpertLevelType}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="ExpertMajor" label="专家专业">
					<template slot-scope="scope">
						<span v-show="scope.row.ExpertMajor == 0">未知</span>
						<span v-show="scope.row.ExpertMajor == 1">超声</span>
						<span v-show="scope.row.ExpertMajor == 2">放射</span>
						<span v-show="scope.row.ExpertMajor == 3">核医学</span>
					</template>
				</el-table-column>
				<el-table-column prop="ModalityTypes" label="擅长设备">
					<template slot-scope="scope">
						<span v-if="scope.row.ModalityTypes == null">—</span>
						<span v-else>{{scope.row.ModalityTypes}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="BodyParts" label="擅长部位">
					<template slot-scope="scope">
						<span v-if="scope.row.BodyParts == null">—</span>
						<span v-else>{{scope.row.BodyParts}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="Title" label="专家职称">
					<template slot-scope="scope">
						<span v-if="scope.row.Title == null">—</span>
						<span v-else>{{scope.row.Title}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="Enable" label="状态">
					<template slot-scope="scope">
						<span v-show="scope.row.Enable == 1">启用</span>
						<span v-show="scope.row.Enable == 0">禁用</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pages">
				<el-pagination class="pageAll" align="center" layout="prev, pager, next" :total="total" :page-size='pages.pageCount'
				 :current-page='pages.pageIndex' @current-change='currentChange'>
				</el-pagination>
			</div>
			<div class="dialog-footer mart10" align="center">
				<el-button type="primary" @click="distributionExport">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<style scoped>

</style>
<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				rules: {},
				dialogVisible: false,
				DistributionType: 2,
				DistributionMethod: 1,
				previewFrom: {
					QCPlanGuid: []
				},
				expertGroupList: [{
					Id: 1,
					Name: 1,

				}, {
					Id: 1,
					Name: 1,

				}],
				newWorkTeamFromList: [],
				selectedIds: [],
				reflush: false,
				Surplusval: true,
				addHosList:[],
				isAllSelect:false
			}
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['distributionFrom', 'SamplingTaskGuId', 'surplusValue','loading','numLoading']),
			...Vuex.mapState('managerUser', ['detailsRulesParameter','getUserlist', 'total', 'pages', 'newWorkTeamFrom', 'NewWorkTeamFromExperts',
				'userParameter'
			]),
			newWorkTeamFroms() {
				return this.newWorkTeamFrom.Experts
			}
		},
		watch: {
			DistributionMethod(news, old) {
				this.setType();
				this.setItemLocal([]);
			},
			DistributionType(news, old) {
				this.newWorkTeamFrom.Experts.forEach(row => {
					row.DistributionRate = 0;
					row.Assigned = 0;
					row.StayFe = 0;
					row.num = 0;
					if (this.DistributionMethod == 3) {
						row.Surplus = row.Count;
					} else {
						row.Surplus = this.surplusValue.num;
					}
				})
				this.setType();
			},
		},
		created() {
			if (localStorage.getItem('SamplingTaskGuId')) {
				this.SamplingTaskGuId.SamplingTaskGuid = localStorage.getItem('SamplingTaskGuId');
				this.GetToDistributeInfo();
			}
			if (!localStorage.getItem('pagedataList')) {
				this.setType();
			} else {
				this.DistributionMethod = JSON.parse(localStorage.getItem('pagedataList')).DistributionMethod;
				this.DistributionType = JSON.parse(localStorage.getItem('pagedataList')).DistributionType;
			}
			this.setLocal();
			this.GetBodyParts()
			this.GetReportModality()
		},
		updated() {
			if (this.NewWorkTeamFromExperts.Experts) {
				this.$refs.multipleTable.clearSelection();
				this.NewWorkTeamFromExperts.Experts = false;
				this.setLocal();
				if (this.newWorkTeamFrom.Experts.length > 0) {
					let UserGuid = this.getUserlist.filter(res => {
						for (let i = 0; i < this.newWorkTeamFrom.Experts.length; i++) {
							if (this.newWorkTeamFrom.Experts[i].UserGuid == res.UserGuid) {
								return res
							}
						}
					})
					UserGuid.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				}
			}
		},
		methods: {
			...Vuex.mapMutations('managerPlanList', ['setSplitScreen', 'setLoading','setnumLoading']),
			...Vuex.mapMutations('managerUser', ['clearUserParameter','clearInit','setUserFromType', 'currentChanges']),
			...Vuex.mapActions('managerPlanList', ['GetToDistributeInfo', 'PostTaskDistribution', 'ChechTaskIsDistribution']),
			...Vuex.mapActions('managerUser', ['userlist','GetBodyParts','GetReportModality']),
			handlefocus(row){
				if (row.DistributionRate == 0) {
					row.DistributionRate = '';
				}
			},
			// 重置
			resetForm(formName) {
				this.clearUserParameter();
				this.search()
			},
			composeValue(index, row,hosindex) {
			      return {
			        index: index,
			        row: row,
					hosindex:hosindex
			      }
			},
			//点击行选中
			clickRow(row) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			//table行添加样式
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.addBtn) {
					return 'rowBorder';
				} else {
					return ''
				}
			},
			//确定分配
			determine() {
				let flag = true;
				if (this.newWorkTeamFrom.Experts.length <= 0) {
					this.$message.error('请选择专家进行分配!');
					return false;
				}
				if (this.newWorkTeamFrom.Experts.length < this.distributionFrom.QCTimes) {
					this.$message.error('选择的专家不能小于' + this.distributionFrom.QCTimes + '位');
					return false;
				}

				let fromNum = 0;
				this.newWorkTeamFrom.Experts.forEach(res => {
					fromNum += res.Assigned;
					if (this.DistributionMethod != 1 && res.DistributionRate == 0) {
						flag = false;
						return false;
					}
					if (this.DistributionMethod == 3 && res.HospitalGuid == '') {
						flag = false;
						return false;
					}
					if (res.Surplus != 0) {
						flag = false;
						return false;
					}
				})

				if (fromNum < this.distributionFrom.Total) {
					flag = false;
					this.$message.error('请将所有可分配数量都进行分配!');
					return false;
				}
				if (flag) {
					this.$confirm("分配之后无法编辑或取消,是否继续?", '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(() => {
						this.setLoading(true);
						this.PostTaskDistribution({
							DistributionMethod: this.DistributionMethod,
							DistributionType: this.DistributionType,
							Experts: JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'))
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消分配'
						});
					});
				} else {
					this.$message.error("还有抽样报告没有分配哦!");
				}

			},
			setType() {
				localStorage.setItem('pagedataList', JSON.stringify({
					DistributionMethod: this.DistributionMethod,
					DistributionType: this.DistributionType
				}))
			},
			//赋值local
			setLocal() {
				if (JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'))) {
					this.newWorkTeamFrom.Experts = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
				}
			},
			setItemLocal(val) {
				this.newWorkTeamFrom.Experts = val;
				this.$forceUpdate();
				localStorage.setItem('NewWorkTeamFromExpertsList', JSON.stringify(val));
			},
			//增项新字段
			setnewWorkTeamList(newWork) {
				if (this.DistributionMethod == 3) {
					this.distributionFrom.Hospitals.filter(res => {
						newWork.forEach(row => {
							if (res.HospitalGuid == row.HospitalGuid) {
								row.TotalNum = res.Count;
							} else {
								row.TotalNum = 0;
							}
							row.DistributionRate = 0;
							row.Assigned = 0;
							row.num = 0;
							row.StayFe = 0;
							row.Surplus = 0;
							row.addBtn = false;
							row.nameType = true;
							row.hoslist = [];
						})
					})
				} else {
					let surplusnum = 0;
					let surplus = 0;
					if (this.DistributionMethod == 2) {
						if (newWork.length > 0) {
							surplus = this.surplusValue.num;
						} else {
							surplus = this.distributionFrom.Total - surplusnum;
						}
					}
					newWork.forEach(row => {
						row.TotalNum = this.distributionFrom.Total;
						row.DistributionRate = 0;
						row.Assigned = 0;
						row.num = 0
						row.StayFe = 0;
						row.Surplus = surplus;
						row.Hospitalslist = '';
						row.addBtn = true;
						row.nameType = true;
						row.hoslist = [];
					})
				}

			},
			// 选择专家
			expertPopUp() {
				this.clearInit();
				this.userParameter.Enable = '1';
				this.pages.pageCount = 10;
				this.setUserFromType(0);
				this.userlist('distribution');
				this.dialogVisible = true;
			},
			//关闭分屏
			closeSplitScreen() {
				this.setLoading(false);
				this.newWorkTeamFrom.Experts = [];
				localStorage.removeItem('NewWorkTeamFromExpertsList');
				this.setSplitScreen(false);
				this.$router.go(-1);
			},
			//计算平均值
			assigned() {
				return Math.floor(this.distributionFrom.Total / this.newWorkTeamFrom.Experts.length)
			},
			totleNum() {
				let num = 0;
				this.newWorkTeamFrom.Experts.forEach((row) => {
					num += row.DistributionRate
				})
				return num;
			},
			setSurplus(row) {
				let newWork = this.newWorkTeamFrom.Experts;
				if (this.DistributionMethod == 3) {
					this.distributionFrom.Hospitals.filter(res => {
						let endNmber = 0;
						for (let i = 0; i < newWork.length; i++) {
							if (res.HospitalGuid == newWork[i].HospitalGuid) {
								endNmber += newWork[i].Assigned;
							}
						}
						for (let i = 0; i < newWork.length; i++) {
							if (res.HospitalGuid == newWork[i].HospitalGuid) {
								newWork[i].Surplus = newWork[i].Count - endNmber;
							}
						}
					})
					
				} else {
					let assignedNum = 0;
					newWork.forEach(res => {
						assignedNum += res.Assigned;
					})
					newWork.forEach(res => {
						res.Surplus = this.distributionFrom.Total - assignedNum;
					})
				}
				this.$forceUpdate();
				this.Surplusval = false;
			},
			search() {
				this.currentChanges(1);
				this.pages.name = this.userParameter.Keyword;
				this.userlist('distribution');
			},
			//确定选择专家
			distributionExport() {
				this.dialogVisible = false;
				let newWork = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
				if (this.DistributionMethod == 1) {
					newWork.forEach((row, index) => {
						let endNmber = 0;
						row.Assigned = Math.floor(this.distributionFrom.Total / this.newWorkTeamFrom.Experts.length);
					})
					newWork[newWork.length - 1].Assigned = Number(this.assigned()) + Number(this.distributionFrom.Total % this.newWorkTeamFrom
						.Experts.length);
					this.newWorkTeamFrom.Experts = newWork;
					this.setItemLocal(newWork);
				}
			},
			//比例点击事件
			handleChange(index, row) {
				row.DistributionRate = Number(row.DistributionRate);
				let preceTotal = 0;
				let surplusTotal = 0;
				let newWorkindex = Number(this.newWorkTeamFrom.Experts.length - 1);
				let newWork = this.newWorkTeamFrom.Experts;
				let errorMsg = '';
				// 平均分1 非平均不限医院2 非平均安医院3
				if (this.DistributionMethod == 2) {
					this.newWorkTeamFrom.Experts.forEach((rows, index) => {
						if (this.DistributionType == 1) {
							preceTotal += rows.DistributionRate;
						} else {
							surplusTotal += rows.DistributionRate;
						}
					})
					if (this.DistributionType == 2 && (surplusTotal > this.distributionFrom.Total)) {
						row.DistributionRate = 0;
						row.Assigned = 0;
						errorMsg = '设置数量不能大于剩余数量';
					}
					if (row.MaxQCCount!=0&&this.DistributionType == 2 && (row.MaxQCCount < row.DistributionRate)) {
						row.DistributionRate = 0;
						row.Assigned = 0;
						errorMsg = '份数设置不能超过专家上限';
					}
				} else if (this.DistributionMethod == 3) {
					for (let i = 0; i < newWork.length; i++) {
						if (row.HospitalGuid == newWork[i].HospitalGuid) {
							if (this.DistributionType == 1) {
								preceTotal += newWork[i].DistributionRate;
							} else {
								surplusTotal += newWork[i].DistributionRate;
							}
						}
					}
					if (this.DistributionType == 2 && (surplusTotal > row.Count)) {
						row.DistributionRate = 0;
						row.Assigned = 0;
						errorMsg = '设置数量不能大于剩余数量';
					}
					if (row.MaxQCCount!=0&&this.DistributionType == 2 && (row.MaxQCCount < row.DistributionRate)) {
						row.DistributionRate = 0;
						row.Assigned = 0;
						errorMsg = '份数设置不能超过专家上限';
					}
					
				}
				//判断填写的数字
				if (row.DistributionRate < 0) {
					row.DistributionRate = 0;
					errorMsg = '数量不能小于0';
				} else if (this.DistributionType == 1 && (preceTotal > 100)) {
					row.DistributionRate = 0;
					row.Assigned = 0;
					errorMsg = '设置比例不能大于100';
				} else if (this.DistributionMethod == 3 && row.HospitalGuid == '') {
					row.DistributionRate = 0;
					row.Assigned = 0;
					errorMsg = '请先选择分配医院';
				} else {
					this.calculationList(row);
					if (row.DistributionRate != 0 && ((this.DistributionType == 1 && row.DistributionRate != 100) || (this.DistributionType ==
							2 && surplusTotal != this.distributionFrom.Total) || (this.DistributionMethod == 3 && this.DistributionType ==
							2 && row.DistributionRate != row.Count))) {
						let asslist = [];
						let assTotal = 0;
						for (let i = 0; i < newWork.length; i++) {
							if (row.HospitalGuid == newWork[i].HospitalGuid) {
								assTotal += newWork[i].Assigned;
								if ((preceTotal == 100 || surplusTotal == newWork[i].Count)) {
									asslist.push(newWork[i]);
								}
							}
						}
						if (this.DistributionMethod == 3) {
							if (asslist.length > 0) {
								this.newWorkTeamFrom.Experts.forEach((res, index) => {
									if (res.uuid == asslist[asslist.length - 1].uuid) {
										res.Assigned = res.Assigned + Number(res.Count - assTotal);
									}
								})
							}
						} else {
							if ((preceTotal == 100 || surplusTotal == this.distributionFrom.Total)) {
								this.newWorkTeamFrom.Experts[newWorkindex].Assigned = Number(this.newWorkTeamFrom.Experts[newWorkindex].Assigned) +
									Number(this.distributionFrom.Total - assTotal);
							}
						}
					}
					if (this.DistributionMethod != 1&&row.MaxQCCount != 0) {
						if (row.MaxQCCount < row.Assigned) {
							row.DistributionRate = 0;
							row.Assigned = 0;
							errorMsg = '份数设置不能超过专家上限';
						}
					}
				}
				// 存在错误信息，直接提示并赋值
				if (errorMsg) {
					this.$message.error(errorMsg);
					this.setSurplus(row);
					this.$set(this.newWorkTeamFrom.Experts, index, row);
					this.setItemLocal(this.newWorkTeamFrom.Experts);
				} else {
					this.setnumLoading(true)
					// 不存在页面校验错误 调用接口校验	
					this.ChechTaskIsDistribution({
						SamplingTaskGuid: this.SamplingTaskGuId.SamplingTaskGuid,
						DistributionType: this.DistributionType,
						DistributionMethod: this.DistributionMethod,
						Experts: this.newWorkTeamFrom.Experts.map((item, itemIndex) => {
							return {
								ExpertUserGuid: item.UserGuid,
								ExpertName: item.Name,
								Count: itemIndex === index ? row.DistributionRate : item.DistributionRate,
								SrcHospitalGuid: item.SrcHospitalGuid
							}
						})
					}).then(res => {
						this.setnumLoading(false)
						const { Experts }  = res
						// 异常
						const unusualFlag = (Experts || []).some(item => item.Code == 0)
						if (unusualFlag) {
							row.DistributionRate = 0;
							row.Assigned = 0;
							this.$message.error('设置异常');
						}  else {
							this.setSurplus(row);
							this.$set(this.newWorkTeamFrom.Experts, index, row);
							this.setItemLocal(this.newWorkTeamFrom.Experts);
						}
					})
				}
			},
			//计算列表
			calculationList(row) {
				let newWork = this.newWorkTeamFrom.Experts;
				//判断比例和数量
				if (this.DistributionMethod != 3) {
					if (this.DistributionType == 1) {
						row.Assigned = Math.floor(this.distributionFrom.Total * (row.DistributionRate / 100));
					} else {
						row.Assigned = row.DistributionRate;
					}
				} else {
					for (let i = 0; i < newWork.length; i++) {
						if (row.HospitalGuid == newWork[i].HospitalGuid) {
							if (this.DistributionType == 1) {
								row.Assigned = Math.floor(row.Count * (row.DistributionRate / 100))
							} else {
								row.Assigned = row.DistributionRate;
							}
						}
					}
				}

			},
			//下拉列表change事件
			handleEvents(index, row, hospitalslist) {
				this.newWorkTeamFrom.Experts.push({
					events: [],
					name: ''
				})
				this.newWorkTeamFrom.Experts.splice(this.newWorkTeamFrom.Experts.length - 1, 1);
				let hospitalsId = this.distributionFrom.Hospitals.filter(res => {
					if (hospitalslist == res.HospitalGuid) {
						return res
					}
				})
				row.Count = hospitalsId[0].Count;
				row.HospitalGuid = hospitalsId[0].HospitalGuid;
				row.HospitalName = hospitalsId[0].HospitalName;
				row.TotalNum = hospitalsId[0].Count;
				row.DistributionRate = 0;
				row.Assigned = 0;
				row.Surplus = hospitalsId[0].Count;
				this.setSurplus(row);
				this.$set(this.newWorkTeamFrom.Experts, index, row);
				this.setItemLocal(this.newWorkTeamFrom.Experts);
			},
			//添加事件
			addClick(command) {
				let row = command.row;
				let index = command.index;
				let hosindex = command.hosindex;
				let uuid = this.uuid();
				let expertsList = {};
				this.newWorkTeamFrom.Experts.forEach(res=>{
					if (res.HospitalName == row.HospitalName) {
						expertsList = res;
					}
				})
				if (expertsList.Assigned == undefined) {
					expertsList.Assigned = 0;
					expertsList.Surplus = row.Count;
				}
				let addRow = {
					id: row.id,
					UserGuid: row.UserGuid,
					ExpertGuid: row.ExpertGuid,
					Name: row.Name,
					LoginId: row.LoginId,
					ExpertFromType: row.ExpertFromType,
					ExpertMajor: row.ExpertMajor,
					CreateDt: row.CreateDt,
					Creator: row.Creator,
					CreatorName: row.CreatorName,
					Enable: row.Enable,
					TotalNum: row.TotalNum,
					DistributionRate: 0,
					Assigned: expertsList.Assigned,
					StayFe: row.StayFe,
					Surplus: expertsList.Surplus,
					Hospitalslist: row.Hospitalslist,
					addBtn: false,
					nameType: false,
					uuid: uuid,
					Count: row.Count,
					ExpertUserGuid: row.ExpertUserGuid,
					HospitalName: row.HospitalName,
					HospitalGuid:row.HospitalGuid
				};
				if (row.HospitalName != '') {
					this.newWorkTeamFrom.Experts[index].hoslist.splice(hosindex, 1);
					this.newWorkTeamFrom.Experts.splice(index + 1, 0, addRow);
					if (this.newWorkTeamFrom.Experts[index].hoslist.length == 0) {
						this.newWorkTeamFrom.Experts[index].addBtn = false;
					}
					this.setItemLocal(this.newWorkTeamFrom.Experts);
				} else {
					this.$message.error('请先选择医院');
				}
			},
			//删除事件
			delterClick(index, row) {
				let _this = this;
				let NewWork = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
				let arg = arguments[2];
				if (arg) {
					_this.deleOper(row);
				} else {
					_this.$confirm('是否确定删除本条分配条件？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(() => {
						if (_this.DistributionMethod == 3) {
							if (NewWork[index] && !row.nameType) {
								for (let i = 0; i < NewWork.length; i++) {
									if (NewWork[i].ExpertGuid == NewWork[index].ExpertGuid) {
										NewWork[i].addBtn = true;
										NewWork[i].hoslist.push(NewWork[index]);
										_this.$set(NewWork, i, NewWork[i]);
										_this.setItemLocal(NewWork);
										break
									}
								}
							}else{
								// NewWork[index].Assigned = 0;
								NewWork[index].hoslist.push(JSON.parse(JSON.stringify(NewWork[index])))
								NewWork[index+1].addBtn = true;
								NewWork[index+1].nameType = true;
								NewWork[index+1].hoslist = NewWork[index].hoslist;
								_this.$set(NewWork, index+1, NewWork[index+1]);
								_this.setItemLocal(NewWork);
							}
							_this.distributionExport();
						}
						_this.deleOper(row);
						_this.setSurplus(row);
					}).catch((err) => {
						_this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				}
			},
			deleOper(row) {
				let _this = this;
				let NewWork = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
				for (let i = 0; i < NewWork.length; i++) {
					if (NewWork[i].uuid == row.uuid) {
						NewWork.splice(i, 1); //删除下标为i的元素
						_this.newWorkTeamFrom.Experts = NewWork;
						_this.setItemLocal(NewWork);
					}
				}
			},
			//分页
			currentChange(val) {
				this.currentChanges(val)
				// this.setUserFromType(0);
				this.userlist('distribution');
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			selectAll(row, first) {
				let _this  = this;
				if (!first) {
					this.isAllSelect = !this.isAllSelect;
				}
				let NewWork = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
				if (row.length == 0) {
					let datawilldele = [];
					for(let i = 0; i < NewWork.length;i++){
					   for(let j = 0; j < _this.getUserlist.length;j++){
						   if(NewWork[i].UserGuid == _this.getUserlist[j].UserGuid){
							  datawilldele.push(i);
						   }
						}
					 }
					 for (let i = 0; i < datawilldele.length; i++) {
					 	NewWork.splice(datawilldele[i]-i,1);
					 	_this.newWorkTeamFrom.Experts = NewWork;
					 	_this.setItemLocal(NewWork);
					 }
				}
			},
			// 当用户手动勾选数据行的 Checkbox 时触发的事件
			selectClick(rows, row) {
				let _this = this;
				let NewWork = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
				let selected = rows.length && rows.indexOf(row) !== -1;
				if (selected) {
				} else {
					let datawilldele = [];//2,4,5
					NewWork.forEach(function (v, i,arry) {
						if (NewWork[i].ExpertGuid == row.ExpertGuid) {
							datawilldele.push(i);
						}
					});
					for (let i = 0; i < datawilldele.length; i++) {
						NewWork.splice(datawilldele[i]-i,1);
						_this.newWorkTeamFrom.Experts = NewWork;
						_this.setItemLocal(NewWork);
					}
				}
			},
			// 勾选事件
			handleSelectionChange(row) {
				let _this = this;
				let list = []
				let NewWork = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
				let result = [];
				this.setnewWorkTeamList(row);
				if (NewWork) {
					list = NewWork;
					for(let i = 0; i < row.length; i++){
						let obj = row[i];
						let num = obj.UserGuid;
						let isExist = false;
						for(let j = 0; j < NewWork.length; j++){
							let aj = NewWork[j];
							let n = aj.UserGuid;
							if(n == num){
								isExist = true;
								break;
							}
						}
						if(!isExist){
							result.push(obj);
						}
					}
				}else{
					result = row;
				}
				let newList = [];
				let hospitalslist = JSON.parse(JSON.stringify(this.distributionFrom.Hospitals));
				if (this.DistributionMethod == 3) {
					result.forEach(item=>{
						hospitalslist.forEach((item1,index)=>{
							if (index == 0) {
								item.nameType = true;
							}else{
								item.nameType = false;
							}
							newList.push(JSON.parse(JSON.stringify(Object.assign(item,item1))))
						})
					})
				}else{
					newList = result
				}
					this.newWorkTeamFrom.Experts = row;
					if (row.length > 0) {
						list.push.apply(list, newList);
						list.forEach(item=>{
							item.uuid = _this.uuid()
						})
						this.setItemLocal(list);
						this.setSurplus(row);
					}
			}

		}
	}
</script>

<style scoped>
	.el-dialog .dialogSearch .selectSearch{
		display: inline-block;
	}
	.exportFrom .selectSearch .el-form-item{
		    width: 226px;
			margin-bottom: 0;
	}
</style>